import { SliderContainerStyled, SliderWrapperStyled } from './Slider.style';
import ListItem from 'components/Blocks/SimpleNavigation/ListItem';
import { getSearchResultLinkType } from 'components/Blocks/SimpleNavigation/SimpleNavigation';
import { ListItemStyled } from 'components/Blocks/SimpleNavigation/SimpleNavigation.style';
import useEmblaCarousel from 'embla-carousel-react';
import { FriendlyPagesTypesKeys } from 'types/friendlyUrl';
import { ListedItemPropType } from 'types/simpleNavigation';

const TEST_IDENTIFIER = 'blocks-simplenavigation-slider-';

type Props = {
    listedItems: ListedItemPropType[];
    type: FriendlyPagesTypesKeys;
};

const Slider: FC<Props> = ({ listedItems, type }) => {
    const [emblaRef] = useEmblaCarousel({
        align: 'start',
        containScroll: 'trimSnaps',
        loop: false,
        duration: 20,
    });

    return (
        <SliderWrapperStyled ref={emblaRef}>
            <SliderContainerStyled>
                {listedItems.map((listedItem, key) => (
                    <ListItemStyled key={key} data-testid={TEST_IDENTIFIER + key}>
                        <ListItem type={getSearchResultLinkType(listedItem, type)} listedItem={listedItem}>
                            {listedItem.name}
                        </ListItem>
                    </ListItemStyled>
                ))}
            </SliderContainerStyled>
        </SliderWrapperStyled>
    );
};

export default Slider;
